import { render, staticRenderFns } from "./AboutIDASB.vue?vue&type=template&id=21abc6b1&"
import script from "./AboutIDASB.vue?vue&type=script&lang=js&"
export * from "./AboutIDASB.vue?vue&type=script&lang=js&"
import style0 from "./AboutIDASB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports